/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetOidcConfiguration = {
  id: 'oidc-configuration.get',
  tag: 'Customer',
  summary: 'Get the OIDC configuration of an organization',
  description: '',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/oidc`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            enabled: z.boolean(),
            issuerUrl: z.string().url(),
            clientId: z.string(),
            clientSecret: z.string(),
            verifyCertificate: z.boolean(),
            domains: z.array(z.string()),
            groupAttribute: z.string().optional(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
